import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** cross, close. Decorative line icon; always pair with a visible text label. */
export function CloseIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M6 6l12 12" />
      <path d="M18 6L6 18" />
    </IconSvg>
  )
}
